import React, { useEffect, useState, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchSettings } from "../../redux/settingsSlice";
import axios from "axios";
import { setUserData } from "../../redux/userSlice";
import { AppContext } from "../../context/AppContext";
import "../../css/Login.css";
import google from "../../images/google.png";
import whatsapp from "../../images/whatsapp.png";
import grass from "../../images/grass.png";
import house from "../../images/leftside-house.png";
import characters from "../../images/Characters.png";
import { useGoogleLogin } from "@react-oauth/google";
import ConfirmationModal from "../modals/ConfirmationModal";

const Login = ({ isOpen, onClose }) => {
  const [showModal, setShowModal] = React.useState(false);
  const [msgTitle, setMsgTitle] = React.useState("");
  const [message, setMessage] = React.useState("");
  const [roleId, setRoleId] = useState(5);
  const [isUserNew, setIsUserNew] = useState(0);
  const handleButtonClick1 = (buttonName) => setRoleId(buttonName);
  const dispatch = useDispatch();
  const { settingsData, status, error1 } = useSelector(
    (state) => state.settings
  );
  const { loggedIN } = useContext(AppContext);
  const [mobileNumber, setMobileNumber] = useState("");
  const [otp, setOtp] = useState("");
  const [isButtonEnabled, setIsButtonEnabled] = useState(false);
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const [timer, setTimer] = useState(60);

  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchSettings());
    }
  }, [dispatch, status]);

  useEffect(() => {
    let interval;
    if (isOtpSent && timer > 0 && !isLoading) {
      interval = setInterval(() => setTimer((prev) => prev - 1), 1000);
    } else {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [isOtpSent, timer, isLoading]);

  useEffect(() => {
    if (!isOpen) {
      setIsOtpSent(false);
      setMobileNumber("");
      setOtp("");
      setIsButtonEnabled(false);
    }
  }, [isOpen]);

  const login = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      try {
        const userInfo = await axios.get(
          "https://www.googleapis.com/oauth2/v3/userinfo",
          {
            headers: { Authorization: `Bearer ${tokenResponse.access_token}` },
          }
        );

        handleGoogleLogin(JSON.stringify(userInfo.data));
      } catch (error) {
        console.error("Error fetching user info:", error);
      }
    },
    onError: (error) => console.error("Login Failed:", error),
  });

  if (!isOpen) return null;

  const handleMobileInputChange = (e) => {
    let value = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
    if (value.length > 10) value = value.slice(0, 10); // Limit to 10 digits

    setMobileNumber(value);
    setIsButtonEnabled(/^[6-9]\d{9}$/.test(value)); // Validate number
  };

  const handleContinueClick = async () => {
    if (!mobileNumber) {
      setShowModal(true);
      setMsgTitle("Please enter a mobile number.");
      setMessage("");
      return;
    }

    if (mobileNumber.length !== 10) {
      setShowModal(true);
      setMsgTitle("Mobile number must be exactly 10 digits.");
      setMessage("");
      return;
    }

    if (!/^[6-9]\d{9}$/.test(mobileNumber)) {
      setShowModal(true);
      setMsgTitle("Invalid mobile number. It must start with 6, 7, 8, or 9.");
      setMessage("");
      return;
    }

    setIsLoading(true);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/loginWithOtp`,
        { username: mobileNumber, role_id: roleId }
      );
      if (response.status === 200) {
        console.log("OTP Sent Successfully");
        setIsOtpSent(true);
        setIsLoading(false);
        setTimer(60);
        setIsUserNew(response.data?.isUserNew);
      }
    } catch (error) {
      console.error("Error verifying:", error);

      if (error.response) {
        if (error.response.status === 403) {
          // alert(error?.response?.data.message || 'Access Denied');
          setShowModal(true);
          setMsgTitle(error?.response?.data.message || "Access Denied");
          setMessage("");
        } else {
          // alert(`Login failed! Error: ${error.response.status}`);
          setShowModal(true);
          setMsgTitle(`Login failed! Error: ${error.response.status}`);
          setMessage("");
        }
      } else {
        // alert('Failed to login. Please check your internet connection.');
        setShowModal(true);
        setMsgTitle("Failed to login. Please check your internet connection.");
        setMessage("");
      }
    }
  };

  const handleOtpChange = (e) => {
    setOtp(e.target.value);
    setIsButtonEnabled(e.target.value.length === 4);
  };

  const handleVerifyOtpClick = async () => {
    if (otp.length !== 4) {
      setShowModal(true);
      setMsgTitle("OTP must be exactly 4 digits.");
      setMessage("");
      return;
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/matchOtp`,
        { username: mobileNumber, otp, isUserNew: isUserNew }
      );
      if (response.status) {
        setIsOtpVerified(true);
        //alert(JSON.stringify(response));
        const { access_token, ...userData } = response.data.data;
        loggedIN(access_token, userData);
        onClose();
      }
    } catch (error) {
      console.error("Error verifying OTP:", error);
      // alert('Failed to verify OTP. Please try again.');
      setShowModal(true);
      setMsgTitle("Failed to verify OTP. Please try again.");
      setMessage("");
    }
  };

  const handleGoogleLogin = async (data) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/OAUTH2`,
        { credentials: data, role_id: roleId }
      );
      if (response.status) {
        const { access_token, ...userData } = response.data.data;
        loggedIN(access_token, userData);
        onClose();
      }
    } catch (error) {
      console.error("Error verifying:", error);

      if (error.response) {
        if (error.response.status === 403) {
          // alert(error?.response?.data.message || 'Access Denied');
          setShowModal(true);
          setMsgTitle(error?.response?.data.message || "Access Denied");
          setMessage("");
        } else {
          // alert(`Login failed! Error: ${error.response.status}`);
          setShowModal(true);
          setMsgTitle(`Login failed! Error: ${error.response.status}`);
          setMessage("");
        }
      } else {
        // alert('Failed to login. Please check your internet connection.');
        setShowModal(true);
        setMsgTitle("Failed to login. Please check your internet connection.");
        setMessage("");
      }
    }
  };

  const handleResendOtp = () => {
    setIsLoading(true);
    handleContinueClick();
    setTimer(60);
  };

  const handleBackClick = () => {
    setIsOtpSent(false);
    setMobileNumber("");
    setOtp("");
    setIsButtonEnabled(false);
    setTimer(60);
  };

  return (
    <div className="modal-overlay loginoutbox">
      {showModal && (
        <ConfirmationModal
          onClose={() => setShowModal(false)}
          title={msgTitle}
          message={message}
          icon="fa fa-times-circle-o"
          theme="red"
        />
      )}
      <div className="modal-content">
        <div className="outer-box">
          <button className="btn-close1" onClick={onClose}>
            X
          </button>
          <div className="login-box">
            <h2>Login To Your Account</h2>
            <div className="user-type">
              <button
                className={`user-button ${roleId === 5 ? "active" : ""}`}
                onClick={() => handleButtonClick1(5)}
              >
                Buyer / Owner
              </button>
              <button
                className={`user-button ${roleId === 6 ? "active" : ""}`}
                onClick={() => handleButtonClick1(6)}
              >
                Agent / Builder
              </button>
            </div>

            <div>
              {!isOtpSent ? (
                <>
                  <input
                    className="input-field mt-4"
                    value={mobileNumber}
                    onChange={handleMobileInputChange}
                    maxLength={10}
                    placeholder="Please Enter Your Phone Number"
                    type="text"
                  />
                  {/* <button className="login-button mt-4" onClick={handleContinueClick} disabled={!isButtonEnabled}>LOGIN</button> */}
                </>
              ) : (
                <>
                  <input
                    className="input-field mt-4"
                    value={otp}
                    onChange={handleOtpChange}
                    maxLength={4}
                    placeholder="Please Enter Your OTP"
                    type="text"
                  />
                  <div className="d-flex gap-2">
                    <button
                      className="login-button mt-3"
                      onClick={handleVerifyOtpClick}
                      disabled={!isButtonEnabled}
                    >
                      Verify OTP
                    </button>
                    <button
                      className="login-button mt-3 d-flex align-items-center justify-content-center gap-1"
                      onClick={handleResendOtp}
                      disabled={timer > 0}
                    >
                      Resend OTP{" "}
                      {timer > 0 && !isLoading ? (
                        `(${timer} sec)`
                      ) : isLoading ? (
                        <span
                          className="spinner-border"
                          role="status"
                          style={{
                            fontSize: "8px",
                            height: "16px",
                            width: "16px",
                          }}
                        >
                          <span className="sr-only">Loading...</span>
                        </span>
                      ) : (
                        ""
                      )}
                    </button>
                  </div>
                  <div>
                    <button
                      className="login-button mt-1 w-25"
                      onClick={() => handleBackClick()}
                    >
                      Back
                    </button>
                  </div>
                </>
              )}
            </div>

            <p className="mt-2 mb-0">- or connect with -</p>
            <div className="social-buttons">
              <button className="google-button" onClick={login}>
                <img src={google} alt="Google" className="button-icon" />
              </button>

              <button
                disabled={isOtpSent ? "disabled" : ""}
                className="whatsapp-button"
                onClick={handleContinueClick}
              >
                <img src={whatsapp} alt="WhatsApp" className="button-icon" />
                {isLoading && !isOtpSent ? (
                  <div
                    class="spinner-border"
                    role="status"
                    style={{ fontSize: "8px", height: "16px", width: "16px" }}
                  >
                    <span class="sr-only">Loading...</span>
                  </div>
                ) : (
                  "WhatsApp"
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
      <img src={grass} alt="Grass" className="grass" />
      <div>
        <img src={characters} alt="Character" className="character mob0" />
        <img src={house} alt="House" className="house mob0" />
      </div>
    </div>
  );
};

export default Login;
